import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog/index';
import DialogActions from '@material-ui/core/DialogActions/index';
import DialogContent from '@material-ui/core/DialogContent/index';
import DialogTitle from '@material-ui/core/DialogTitle/index';
import Grid from "@material-ui/core/Grid";

import Divider from "@material-ui/core/Divider";
import DraggableModal from "../../../../Include/DraggableModal/DraggableModal";
import {FieldsJs} from "../../../../../settings/General/General";
import Slide from "@material-ui/core/Slide";
import {TituloHeaderModal} from "../../../../Include/MiniComponents/GlobalComponent";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import Table from "@material-ui/core/Table";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableBody from "@material-ui/core/TableBody";
import Paper from "@material-ui/core/Paper";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import FormGroup from "@material-ui/core/FormGroup";
import {HttpRequest} from "../../../../../settings/HttpRequest/HttpRequest";
import {CatService} from "../../../../../services/_Cat/CatService/CatService";
import {Business, Description, FontDownload, HdrStrong, HomeWork, LooksOne, Person, Room} from "@material-ui/icons";
import TextField from "@material-ui/core/TextField";
import {DateFormat} from "../../../../../settings/DateFormat/DateFormat";
import FiltrosClienteReceptoraPago from "./FiltrosClienteReceptoraPago";
import FiltrosCertificados from "./FiltrosCertificados";
import {ReactLocalStorageService} from "../../../../../settings/ReactLocalStorageService/ReactLocalStorageService";
import ClienteReceptoraPagoService from "../../../../../services/_Cat/ClienteReceptoraPagoService/ClienteReceptoraPagoService";
import TableHead from "@material-ui/core/TableHead";
import Avatar from "@material-ui/core/Avatar";
import {CONFIG} from "../../../../../settings/Config/Config";
import ModalDomicilioFiscal from "./ModalDomicilioFiscal";
import Tooltip from "@material-ui/core/Tooltip";
import Zoom from "@material-ui/core/Zoom";
import IconButton from "@material-ui/core/IconButton";
import ModalCIF from "./ModalCIF";
import EmpresaAcrescoSucursal from "../../EmpresaAcrescoSucursal/EmpresaAcrescoSucursal";
import ClienteReceptoraPagoDatoBancario from "../../ClienteReceptoraPagoDatoBancario/ClienteReceptoraPagoDatoBancario";
import EmpresaAcrescoCertificado from "../../EmpresaAcrescoCertificado/EmpresaAcrescoSucursal";
import DeleteOutlined from "@material-ui/icons/DeleteOutlined";
import ModalClienteReceptoraPago from "./ModalClienteReceptoraPago";
import Paginacion from "../../../../Include/Paginacion/Paginacion";
import BarraProgreso from "../../../Tickets/Includes/BarraProgreso";


class ModalCertificados extends Component {
	
	state = {};
	
	showSnackBars = this.props.showSnackBars;
	
	constructor(props) {
		super(props);
		
		this.state = {
			modal: {
				open: false
			},
			
			lista: [],
			
			filtro: {
				activo: 'all'
			},
			
			paginacion: {
				total: null,
				page: 1,
				limit: this.DefaultNumPag(),
				rangos: this.DefaultRangos()
			},
		};
	
	}
	
	handleChange = (e, variable, campo, date, input) => {
		FieldsJs.HandleChange(e, variable, campo, date, input, (r) => this.setState({
			[r.name]: r.value
		}));
	};
	
	changeValue = (arr_name__key, var_name, var_value) => {
		FieldsJs.ChangeValue(arr_name__key, var_name, var_value, (r) => this.setState({
			[r.name]: r.value
		}), this.state);
	};
	
	closeModal = () => {
		this.setState({
			modal: {
				open: false
			}
		});
	};
	
	close = () => {
		this.closeModal();
	};
	
	openModal = () => {
		const props = this.props;
		this.setState({
			modal: {
				open: true
			},
		});
	};
	
	open = () => {
		this.init().then(r => {
			this.Listar();
			setTimeout(() => this.openModal());
		}).catch(e => {
		});
	};
	
	RefreshInit = () => {
		this.init();
	};
	
	init = () => {
		return new Promise((resolve) => {
			resolve(true);
		});
	};
	
	HandleFiltro = (filtro) => {
		this.setState({
			filtro: filtro
		});
	};
	
	DefaultNumPag = () => {
		let Cfg = ReactLocalStorageService.get('Cfg') || {};
		return Cfg.paginacion_numero_registro ? Number(Cfg.paginacion_numero_registro) : 10;
	};
	
	DefaultRangos = () => {
		let Cfg = ReactLocalStorageService.get('Cfg') || {};
		let rangos = [5, 10, 15, 20];
		if (FieldsJs.Array(Cfg.paginacion_rangos)) {
			rangos = Cfg.paginacion_rangos;
		}
		return rangos;
	};
	
	Listar = () => {
		ClienteReceptoraPagoService.ListarCertificados(this.state.filtro, this.state.paginacion).then((response) => {
			this.setState({
				lista: response.data,
				
				paginacion: {
					total: response.paginacion.total,
					page: response.paginacion.page,
					limit: response.paginacion.limit,
					rangos: this.DefaultRangos()
				}
			});
		}).catch((error) => {
			this.setState({
				listar_cat_cliente_receptora_pago: []
			});
			this.showSnackBars('error', error.mensaje);
		});
	};
	
	AplicarPaginacion = (data) => {
		let paginacion = this.state.paginacion;
		this.setState({
			paginacion: {
				total: paginacion.total || null,
				page: data.page || paginacion.page || null,
				limit: data.limit || paginacion.limit || this.DefaultNumPag(),
				rangos: this.DefaultRangos()
			}
		});
		setTimeout(() => this.Listar());
	};
	
	AplicarFiltros = () => {
		let paginacion = this.state.paginacion;
		this.setState({
			paginacion: {
				total: paginacion.total || null,
				page: 1,
				limit: paginacion.limit || this.DefaultNumPag(),
				rangos: this.DefaultRangos()
			}
		});
		setTimeout(() => this.Listar());
	};
	
	
	exportaryenviar = (item, archivo, auth, email) => {
		try {
			
			let filtro = {
				rfc: this.state.filtro.rfc || null,
				empresa: this.state.filtro.empresa || null,
				certificado: this.state.filtro.certificado || null,
				estatus: this.state.filtro.estatus || null,
				activo: (Number(this.state.filtro.activo) === 1 || Number(this.state.filtro.activo) === 0) ? Number(this.state.filtro.activo) : null,
			};
			
			let params = {
				auth: auth,
				archivo: archivo,
				filtro: filtro,
			};
			
			HttpRequest.export('empresas_acresco_certificados', ['empresas_acresco_certificados'], params, false, false, false, archivo === "EXCEL")
			
			
		} catch (e) {
			this.showSnackBars('error', e.mensaje);
		}
	};
	
	
	render() {
		
		return (
			<div>
				
				<Fragment>
					<span style={{cursor: 'pointer'}} children={this.props.componente} onClick={() => this.open()}/>
				</Fragment>
				
				<Dialog open={this.state.modal.open} onClose={() => this.close()} PaperComponent={DraggableModal}
				        disableEscapeKeyDown disableBackdropClick maxWidth={'lg'} fullWidth={true} scroll={'paper'}
				        transition={<Slide direction="up"/>} aria-labelledby="scroll-dialog-title"
				>
					
					<DialogTitle>
						<TituloHeaderModal
							tipo={this.state.tipo}
							titulo={'Certificados'}
						/>
					</DialogTitle>
					
					<DialogContent>
						
						<Grid container spacing={1} className={'desing-acresco-excel-export'}>
							
							<Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
								<FiltrosCertificados
									AplicarFiltros={this.AplicarFiltros}
									HandleFiltro={this.HandleFiltro}
									showSnackBars={this.showSnackBars}
									/>
							</Grid>
							
							<Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
								<Divider/>
							</Grid>
							<Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
								<Paper style={{overflowX: "auto"}}>
									<Table className={'desing-acresco'}>
										<TableHead>
											<TableRow>
												<TableCell component="th" align={'center'} className={'w-10-px padding-20-L padding-10-R'}>
													ID
												</TableCell>
												<TableCell component="th" align={'center'} className={'padding-30-R'}>RFC</TableCell>
												<TableCell component="th" align={'left'}>Razón Social</TableCell>
												<TableCell component="th" align={'center'}>Tipo Certificado</TableCell>
												<TableCell component="th" align={'center'}>Estatus</TableCell>
												<TableCell component="th" align={'center'} className={'w-110-px'}>Vigencia</TableCell>
												<TableCell component="th" align={'center'} className={'w-110-px'}>Días Vigencia</TableCell>
											</TableRow>
										</TableHead>
										<TableBody>
											{this.state.lista.map((item, key) => (
												<TableRow key={key}>
													<TableCell align={'center'} className={'padding-20-L padding-20-R'}>
														{key + 1}
													</TableCell>
													<TableCell align={'left'}>{item.rfc}</TableCell>
													<TableCell align={'left'}>{item.razon_social}</TableCell>
													<TableCell align={'left'}>{item.tipo_certificado}</TableCell>
													<TableCell align={'left'}>{item.estatus}</TableCell>
													<TableCell align={'center'}>{item.fecha_vencimiento}</TableCell>
													<TableCell align={'center'}>{item.fecha_vigencia}</TableCell>
												</TableRow>
											))}
										</TableBody>
									</Table>
								</Paper>
							</Grid>
							
							<Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
								<Paginacion
									total={this.state.paginacion.total}
									page={this.state.paginacion.page}
									limit={this.state.paginacion.limit}
									rangos={this.state.paginacion.rangos}
									onClick={(data) => this.AplicarPaginacion(data)}
								/>
							</Grid>
							{/*<Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
								<Divider/>
							</Grid>*/}
						
						</Grid>
					
					</DialogContent>
					
					<Divider/>
					
					<DialogActions>
						
						<Fragment>
							<Grid container spacing={1}>
								<Grid item xs={6} sm={6} md={6} lg={6} xl={6} align={'left'}>
									<Button onClick={() => this.exportaryenviar({}, 'EXCEL')} color="primary">
										Exportar
									</Button>
								</Grid>
								<Grid item xs={6} sm={6} md={6} lg={6} xl={6} align={'right'}>
									<Button onClick={this.close} color="primary">
										Cancelar
									</Button>
								</Grid>
							</Grid>
						</Fragment>
					
					</DialogActions>
				
				</Dialog>
			
			</div>
		);
	}
}

ModalCertificados.propTypes = {
	componente: PropTypes.element,
	tipo: PropTypes.string,
	item: PropTypes.object.isRequired,
	filtro: PropTypes.object,
	RefreshList: PropTypes.func.isRequired,
	showSnackBars: PropTypes.func.isRequired,
};

export default ModalCertificados;
